module.exports = __webpack_public_path__ + "static/nkbm-0509a4479273ceda68afdd07c677b12b.png";